import OrbitAvatar from '@/components/OrbitAvatar'
import { Member } from '@/services/member/member.model'
import { Space, Tag } from 'antd'
import React, { memo } from 'react'

interface MemberNameProps {
  member: Member.Info
}

export const MemberName = memo(({ member }: MemberNameProps) => {
  const { organization } = member
  const avatar = organization ? organization.avatar : member.avatar
  const name = organization ? organization.name : member.fullName
  const email = organization ? organization.contactEmail : member.email
  return (
    <Space className={'w100'}>
      <OrbitAvatar size={36} avatar={avatar} name={name} />
      <Space direction={'vertical'} align={'start'} size={0}>
        <Space align={'start'} size={10}>
          <a>{name}</a>
          {organization && <Tag color='#2db7f5'>Organization</Tag>}
        </Space>
        <span>
          {organization && <span>Contact Email: </span>}
          {email}
        </span>
      </Space>
    </Space>
  )
})
